import { useParams } from 'react-router-dom';
import Panel from '~/components/Panel';
import Breadcrumb from '~/components/Breadcrumbs/Breadcrumb';
import UserProfilePanel from '~/components/Users/UserProfilePanel';
import UserProfileTitlePanel from '~/components/Users/UserProfileTitlePanel';
import AdminTabs from '../../components/Users/AdminTabs';
import ClientTabs from '~/components/Users/ClientTabs';
import TeamMemberTabs from '~/components/Users/TeamMemberTabs';
import MedProfessionalTabs from '~/components/Users/MedProfessionalTabs';
import { useQuery } from '@tanstack/react-query';
import { fetchUser } from '~/services/users';
import { useUserContext } from '~/context/UserProvider';

const UserProfile = () => {
    const { user, userDispatch } = useUserContext();
    const { id } = useParams();

    const getUser = async (id: string) => {
        const response = await fetchUser(id);
        userDispatch({
            type: 'set_user',
            payload: response,
        });
        return response;
    };

    const { data, refetch } = useQuery({
        queryKey: ['user', id],
        queryFn: () => id && getUser(id),
    });
    const roles = user?.roles;

    return (
        <>
            <Breadcrumb
                pageName='User Profile'
                parentPage='Users'
                parentPath='/users'
            />

            <Panel>{user && <UserProfileTitlePanel />}</Panel>

            <div className='flex'>
                <Panel addClasses={'mt-[20px] bg-white border-stroke w-1/4'}>
                    {user && <UserProfilePanel />}
                </Panel>

                <Panel
                    addClasses={
                        'mt-[20px] ml-[20px] bg-white border-stroke w-3/4'
                    }
                >
                    {(roles?.includes('administrator') ||
                        roles?.includes('staff')) && <AdminTabs user={user} />}
                    {roles?.includes('patient') && <ClientTabs user={user} />}
                    {roles?.includes('medical professional') && (
                        <MedProfessionalTabs user={user} />
                    )}
                    {(roles?.includes('full team member') ||
                        roles?.includes('limited team member') ||
                        roles?.includes('no access team member')) && (
                            <TeamMemberTabs user={user} />
                        )}
                </Panel>
            </div>
        </>
    );
};

export default UserProfile;
